function removeAccents(str: string): string {
	const defaultDiacriticsRemovalMap = [
		{ 'base': 'a', 'letters': /[àâä]/g },
		{ 'base': 'c', 'letters': /[ç]/g },
		{ 'base': 'e', 'letters': /[éèêë]/g },
		{ 'base': 'i', 'letters': /[îïì]/g },
		{ 'base': 'o', 'letters': /[ôö]/g },
		{ 'base': 'u', 'letters': /[ûüù]/g },
	];

	for (let i = 0; i < defaultDiacriticsRemovalMap.length; i++) {
		str = str.replace(defaultDiacriticsRemovalMap[i].letters, defaultDiacriticsRemovalMap[i].base);
	}

	return str;
}

export function slugify(string: string): string {
	return removeAccents(string.toLowerCase())
		.replace(/[^a-z -]/g, '')
		.replace(/^[ -]/g, '')
		.replace(/[ -]$/g, '')
		.replace(/[ ]/g, '-');
}